/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AffectedEntitiesResponse
 */
export interface AffectedEntitiesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AffectedEntitiesResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AffectedEntitiesResponse
     */
    vulnerabilityId?: string;
    /**
     * 
     * @type {string}
     * @memberof AffectedEntitiesResponse
     */
    assetId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AffectedEntitiesResponse
     */
    affectedEntityIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AffectedEntitiesResponse
     */
    count?: number;
}

/**
 * Check if a given object implements the AffectedEntitiesResponse interface.
 */
export function instanceOfAffectedEntitiesResponse(value: object): value is AffectedEntitiesResponse {
    return true;
}

export function AffectedEntitiesResponseFromJSON(json: any): AffectedEntitiesResponse {
    return AffectedEntitiesResponseFromJSONTyped(json, false);
}

export function AffectedEntitiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffectedEntitiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'vulnerabilityId': json['vulnerabilityId'] == null ? undefined : json['vulnerabilityId'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'affectedEntityIds': json['affectedEntityIds'] == null ? undefined : json['affectedEntityIds'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function AffectedEntitiesResponseToJSON(json: any): AffectedEntitiesResponse {
    return AffectedEntitiesResponseToJSONTyped(json, false);
}

export function AffectedEntitiesResponseToJSONTyped(value?: AffectedEntitiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'vulnerabilityId': value['vulnerabilityId'],
        'assetId': value['assetId'],
        'affectedEntityIds': value['affectedEntityIds'],
        'count': value['count'],
    };
}

